import {
  CheckOutlined,
  CloseOutlined,
  CopyOutlined,
  DeleteOutlined,
  EditOutlined,
  LineChartOutlined,
} from "@ant-design/icons";
import { BotTemplates } from "@dots-projects/types";
import { Button, Modal, Popconfirm, Space, Switch, Table } from "antd";
import { ColumnsType } from "antd/es/table";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { DiscordTriggersRpc } from "../../lib/discordTypes";
import DotsFishLoading from "../DotsFishLoading/DotsFishLoading";
import NewDiscordTrigger from "./NewDiscordTrigger";
import TemplatesBox from "./TemplatesBox";

type Props = {
  loadExecTriggers: any;
  execTriggers: any;
  changeTriggerVisibility: any;
  archiveTrigger: any;
  backgroundPosition: string[];
  botTemplates: BotTemplates[];
  newRoute?: boolean;
};

export default function AutomationsPage({
  loadExecTriggers,
  execTriggers,
  changeTriggerVisibility,
  archiveTrigger,
  backgroundPosition,
  botTemplates,
  newRoute = false,
}: Props) {
  const navigate = useNavigate();
  const [openModal, setOpenModal] = useState<boolean>(newRoute);

  // Table columns
  const columns: ColumnsType<DiscordTriggersRpc> = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      width: "40%",
      sorter: (a: any, b: any) => a.name - b.name,
      render: (name, trigger) => (
        <Space>
          <Switch
            checkedChildren={<CheckOutlined />}
            unCheckedChildren={<CloseOutlined />}
            defaultChecked
            checked={trigger.is_active}
            onChange={() => changeTriggerVisibility(trigger)}
          />
          <Link
            to={`/automation/${trigger.trigger_id}`}
            className="text-black hover:text-gray-700"
          >
            {name}
          </Link>
        </Space>
      ),
    },
    {
      title: "Created by",
      dataIndex: "created_by",
      key: "created_by",
      width: "20%",
    },
    {
      title: "Actions",
      key: "action",
      width: "40%",
      render: (trigger: DiscordTriggersRpc) => (
        <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
          <Link to={`/automation/${trigger.trigger_id}/edit`}>
            <Button
              style={{ color: "#FF7555", display: "flex" }}
              onClick={() => {
                window.analytics.track("Trigger - Edit trigger action clicked");
              }}
            >
              <EditOutlined className="mt-1" /> <p>Edit</p>
            </Button>
          </Link>
          <Link to={`/automation/${trigger.trigger_id}`}>
            <Button
              style={{ color: "#FF7555", display: "flex" }}
              onClick={() =>
                window.analytics.track("Trigger - Track trigger action clicked")
              }
            >
              <LineChartOutlined className="mt-1" /> <p>Track</p>
            </Button>
          </Link>
          <Link
            to={`/automation/new?type=scratch&trigger_id=${trigger.trigger_id}`}
          >
            <Button
              style={{ color: "#FF7555", display: "flex" }}
              onClick={() =>
                window.analytics.track("Trigger - Track trigger action clicked")
              }
            >
              <CopyOutlined className="mt-1" /> <p>Copy</p>
            </Button>
          </Link>
          <Popconfirm
            title={`Are you sure you want to delete "${trigger.name}"?`}
            okText="Yes"
            cancelText="No"
            onConfirm={() => archiveTrigger(trigger)}
          >
            <Button
              style={{ color: "#FF7555", display: "flex" }}
              onClick={() => {
                window.analytics.track(
                  "Trigger - Delete trigger action clicked"
                );
              }}
            >
              <DeleteOutlined className="mt-1" /> <p>Delete</p>
            </Button>
          </Popconfirm>
        </div>
      ),
    },
  ];

  // if path is /new, open the new automation modal
  useEffect(() => {
    setOpenModal(newRoute);
  }, [newRoute]);

  // pull triggers on first render
  useEffect(() => {
    loadExecTriggers();
  }, []);

  return (
    <>
      <Modal
        visible={openModal}
        okButtonProps={{ hidden: true }}
        onCancel={() => {
          navigate("/automation");
        }}
        footer={null}
        cancelButtonProps={{ style: { display: "none" } }}
        width={1000}
        style={{ top: "8vh" }}
      >
        <NewDiscordTrigger
          backgroundPosition={backgroundPosition}
          botTemplates={botTemplates}
        />
      </Modal>
      <TemplatesBox
        backgroundPosition={backgroundPosition}
        botTemplates={botTemplates}
      />
      <h3 className="text-sm mb-4 mt-8 text-left">Existing bots</h3>
      {execTriggers ? (
        <Table
          size="small"
          columns={columns}
          dataSource={execTriggers || []}
          rowKey="trigger_id"
          pagination={{
            defaultPageSize: 50,
            showSizeChanger: true,
            pageSizeOptions: ["50", "100", "200"],
          }}
        />
      ) : (
        <DotsFishLoading />
      )}
    </>
  );
}
